import { RouteType } from "../../../types/RouteType";

const concreteTestEntryRoute: RouteType = {
  name: "Concrete Test Entry",
  path: "/qc/concrete-test",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./ConcreteTestEntry.Header"),
      title: "Concrete Test Entry",
      color: "primary",
    },
    body: {
      component: () => import("./ConcreteTestEntry.Body"),
      grayBackground: true,
    },
  },
  group: "Quality Control",
  requiresAuth: true,
  requiresPermission: false,

  beforeEnter: async () => {
    return true;
  },

  dialogs: [],
};

export default concreteTestEntryRoute;
